import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../../css/tablestandings.css';

const FootballTables = () => {
    const [englishPremierLeague, setEnglishPremierLeague] = useState([]);
    const [englishChampionship, setEnglishChampionship] = useState([]);
    const [englishLeagueOne, setEnglishLeagueOne] = useState([]);
    const [englishLeagueTwo, setEnglishLeagueTwo] = useState([]);
    const [englishNationalLeague, setEnglishNationalLeague] = useState([]);    

    const [worldCupGroupA, setWorldCupGroupA] = useState([]);
    const [worldCupGroupB, setWorldCupGroupB] = useState([]);
    const [worldCupGroupC, setWorldCupGroupC] = useState([]);
    const [worldCupGroupD, setWorldCupGroupD] = useState([]);
    const [worldCupGroupE, setWorldCupGroupE] = useState([]);
    const [worldCupGroupF, setWorldCupGroupF] = useState([]);
    const [worldCupGroupG, setWorldCupGroupG] = useState([]);
    const [worldCupGroupH, setWorldCupGroupH] = useState([]);
    const [worldCupGroupI, setWorldCupGroupI] = useState([]);
    const [worldCupGroupJ, setWorldCupGroupJ] = useState([]);
    const [worldCupGroupK, setWorldCupGroupK] = useState([]);
    const [worldCupGroupL, setWorldCupGroupL] = useState([]);
    
    /*
    const [africaCupOfNationsGroupA, setAfricaCupOfNationsGroupA] = useState([]);
    const [africaCupOfNationsGroupB, setAfricaCupOfNationsGroupB] = useState([]);
    const [africaCupOfNationsGroupC, setAfricaCupOfNationsGroupC] = useState([]);
    const [africaCupOfNationsGroupD, setAfricaCupOfNationsGroupD] = useState([]);
    const [africaCupOfNationsGroupE, setAfricaCupOfNationsGroupE] = useState([]);
    const [africaCupOfNationsGroupF, setAfricaCupOfNationsGroupF] = useState([]);
    */

    function getRowClass(index, competition) {
        let position = ++index;

        if ((competition == 'PremierLeague' && position >= 1 && position <= 4) ||
            (competition == 'Championship' && position >= 1 && position <= 2) ||
            (competition == 'LeagueOne' && position >= 1 && position <= 2) ||
            (competition == 'LeagueTwo' && position >= 1 & position <= 3) ||
            (competition == 'NationalLeague' && position == 1) ||
            (competition == 'WorldCup' && position == 1) ||
            (competition == 'AfricaCupOfNations' && position == 1)) {
            return "automatic-promotion";
        }

        if (
            (competition == 'Championship' && position >= 2 && position <= 6) ||
            (competition == 'LeagueOne' && position >= 2 && position <= 6) ||
            (competition == 'LeagueTwo' && position >= 2 & position <= 7) ||
            (competition == 'NationalLeague' && position >= 2 & position <= 7) ||
            (competition == 'WorldCup' && position == 2)) {        
            return "playoffs";
        }

        if ((competition == 'PremierLeague' && position >= 18) ||
            (competition == 'Championship' && position >= 22) ||
            (competition == 'LeagueOne' && position >= 21) ||
            (competition == 'LeagueTwo' && position >= 23) ||
            (competition == 'NationalLeague' && position >= 21)) {
            return "relegation";
        }
    }

    useEffect(() => {
        let apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=EnglishPremierLeague';
        axios.get(apiUrl).then((result) => {            
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setEnglishPremierLeague(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=EnglishChampionship';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setEnglishChampionship(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=EnglishLeagueOne';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setEnglishLeagueOne(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=EnglishLeagueTwo';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setEnglishLeagueTwo(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=EnglishNationalLeague';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setEnglishNationalLeague(tableRows);
        });
        
        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupA';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupA(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupB';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupB(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupC';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupC(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupD';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupD(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupE';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupE(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupF';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupF(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupG';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupG(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupH';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupH(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupI';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupI(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupJ';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupJ(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupK';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupK(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=WorldCupGroupL';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setWorldCupGroupL(tableRows);
        });

        /*
        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=AfricaCupOfNationsGroupA';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setAfricaCupOfNationsGroupA(tableRows);
        });

        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=AfricaCupOfNationsGroupB';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setAfricaCupOfNationsGroupB(tableRows);
        });
        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=AfricaCupOfNationsGroupC';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setAfricaCupOfNationsGroupC(tableRows);
        });
        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=AfricaCupOfNationsGroupD';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setAfricaCupOfNationsGroupD(tableRows);
        });
        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=AfricaCupOfNationsGroupE';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setAfricaCupOfNationsGroupE(tableRows);
        });
        apiUrl = 'https://dotnet-function-apps.azurewebsites.net/api/Football_TableStandingsHttpTrigger?division=AfricaCupOfNationsGroupF';
        axios.get(apiUrl).then((result) => {
            var tableData = result.data.Data;
            var tableRows = tableData.slice(1);
            setAfricaCupOfNationsGroupF(tableRows);
        });
        */
    }, []);


    return (
        <React.Fragment>
            <article id="football-tables">
                <div className='row'>
                    <div>
                        <h6><span>English Premier League</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {englishPremierLeague && englishPremierLeague.map((item, index) =>  (                                    
                                    <tr key={`tr${index}`} className={getRowClass(index, 'PremierLeague')}>
                                        {item.map((_, y) => (                                            
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>English Championship</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {englishChampionship && englishChampionship.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'Championship')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>English League One</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {englishLeagueOne && englishLeagueOne.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'LeagueOne')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>English League Two</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {englishLeagueTwo && englishLeagueTwo.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'LeagueTwo')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>English National League</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {englishNationalLeague && englishNationalLeague.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'NationalLeague')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group A</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupA && worldCupGroupA.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group B</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupB && worldCupGroupB.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group C</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupC && worldCupGroupC.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group D</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupD && worldCupGroupD.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group E</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupE && worldCupGroupE.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group F</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupF && worldCupGroupF.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group G</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupG && worldCupGroupG.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group H</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupH && worldCupGroupH.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group I</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupI && worldCupGroupI.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group J</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupJ && worldCupGroupJ.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group K</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupK && worldCupGroupK.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>World Cup Group L</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {worldCupGroupL && worldCupGroupL.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'WorldCup')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>                                        
                    {/*
                    <div>
                        <h6><span>Africa Cup Of Nations Group A</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {africaCupOfNationsGroupA && africaCupOfNationsGroupA.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'AfricaCupOfNations')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>Africa Cup Of Nations Group B</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {africaCupOfNationsGroupB && africaCupOfNationsGroupB.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'AfricaCupOfNations')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>Africa Cup Of Nations Group C</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {africaCupOfNationsGroupC && africaCupOfNationsGroupC.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'AfricaCupOfNations')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>Africa Cup Of Nations Group D</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {africaCupOfNationsGroupD && africaCupOfNationsGroupD.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'AfricaCupOfNations')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>Africa Cup Of Nations Group E</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {africaCupOfNationsGroupE && africaCupOfNationsGroupE.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'AfricaCupOfNations')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        <h6><span>Africa Cup Of Nations Group F</span></h6>
                        <table className="alt football-standings">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Team</th>
                                    <th>P</th>
                                    <th>W</th>
                                    <th>D</th>
                                    <th>L</th>
                                    <th>GF</th>
                                    <th>GA</th>
                                    <th>GD</th>
                                    <th>Pts</th>
                                </tr>
                            </thead>
                            <tbody>
                                {africaCupOfNationsGroupF && africaCupOfNationsGroupF.map((item, index) => (
                                    <tr key={`tr${index}`} className={getRowClass(index, 'AfricaCupOfNations')}>
                                        {item.map((_, y) => (
                                            <td key={`td-${item[1]}-${y}`}>{item[y]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    */}
                </div>
            </article>
        </React.Fragment>
    );
}

export default FootballTables;